
// src/utils/format.js this code for help to registration request 
export function formatDateTime(ts) {
  try {
    if (!ts) return "-";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString();
  } catch {
    return "-";
  }
}
